import { createStore } from "redux";

const initialState = {
  count: 0,
  overlaySpinner: true,
  filter_result_json: {},
  tillSqlSelectionArr: [],
  afterSqlSelectionArr: [],
  groupLeveltoggle: [],
  ruleLeveltoggle: [],
  isModalOpen: "",
  queryCount: {
    query_count: " ",
    full_count: " ",
    address_count: " ",
    email_count: " ",
    total_audience_email_count: " ",
    total_audience_email_pre: " ",
    total_audience_email_eclub: " ",
    total_non_mkt: " ",
    total_mkt: " ",
    non_eclub_emails: " ", 
    non_preclub_emails: " ",
    non_email_custs: " ",
    non_direct_mail: " "
  },
  showQuerySpinner: "no",
  previewData: [],
  countService: [],
  segmentName: [],
  segmentData: [],
  countSegment: 0,
  tillSqlSelectionArrSegment: [],
  afterSqlSelectionArrSegment: [],
  groupLeveltoggleSegment: [],
  ruleLeveltoggleSegment: [],
  isModalOpenSegment: "",
  queryCountSegment: {
    query_count: " ",
    full_count: " ",
    address_count: " ",
    email_count: " ",
    total_audience_email_count: " ",
    total_audience_email_pre: " ",
    total_audience_email_eclub: " ",
    total_non_mkt: " ",
    total_mkt: " ",
    non_eclub_emails: " ", 
    non_preclub_emails: " ",
    non_email_custs: " ",
    non_direct_mail: " "
  },
  showQuerySpinnerSegment: "no",
  previewDataSegment: [],
  countServiceSegment: [],
  hideTabs: "yes",
  queryCountTempSegment: {
    query_count: " ",
    full_count: " ",
    address_count: " ",
    email_count: " ",
    total_audience_email_count: " ",
    total_audience_email_pre: " ",
    total_audience_email_eclub: " ",
    total_non_mkt: " ",
    total_mkt: " ",
    non_eclub_emails: " ", 
    non_preclub_emails: " ",
    non_email_custs: " ",
    non_direct_mail: " "
  },
  sliderValue: {
    sliderValue: 0,
    excludedCount: 0
  },
  summaryDetails : {query_details : {condition: "", value: ""}, charts_details : {condition: "", value: ""}, segment_details : {condition: "", value: ""}, filter_tab_details : {condition: "", value: ""}, segments_tab_details : {condition: "", value: ""}},
  // summaryDetails : ""

  cust_count: 0,
  cust_tillSqlSelectionArr: [],
  cust_afterSqlSelectionArr: [],
  cust_groupLeveltoggle: [],
  cust_ruleLeveltoggle: [],
  cust_isModalOpen: "",
  cust_queryCount: {
    query_count: " ",
    full_count: " ",
    address_count: " ",
    email_count: " ",
    total_audience_email_count: " ",
    total_audience_email_pre: " ",
    total_audience_email_eclub: " ",
    total_non_mkt: " ",
    total_mkt: " ",
    non_eclub_emails: " ", 
    non_preclub_emails: " ",
    non_email_custs: " ",
    non_direct_mail: " "
  },
  cust_showQuerySpinner: "no",
  cust_previewData: [],
  cust_countService: [],
  cust_segmentName: [],
  cust_segmentData: [],
  cust_countSegment: 0,
  cust_tillSqlSelectionArrSegment: [],
  cust_afterSqlSelectionArrSegment: [],
  cust_groupLeveltoggleSegment: [],
  cust_ruleLeveltoggleSegment: [],
  cust_isModalOpenSegment: "",
  cust_queryCountSegment: {
    query_count: " ",
    full_count: " ",
    address_count: " ",
    email_count: " ",
    total_audience_email_count: " ",
    total_audience_email_pre: " ",
    total_audience_email_eclub: " ",
    total_non_mkt: " ",
    total_mkt: " ",
    non_eclub_emails: " ", 
    non_preclub_emails: " ",
    non_email_custs: " ",
    non_direct_mail: " "
  },
  cust_showQuerySpinnerSegment: "no",
  cust_previewDataSegment: [],
  cust_countServiceSegment: [],
  cust_hideTabs: "yes",
  cust_queryCountTempSegment: {
    query_count: " ",
    full_count: " ",
    address_count: " ",
    email_count: " ",
    total_audience_email_count: " ",
    total_audience_email_pre: " ",
    total_audience_email_eclub: " ",
    total_non_mkt: " ",
    total_mkt: " ",
    non_eclub_emails: " ", 
    non_preclub_emails: " ",
    non_email_custs: " ",
    non_direct_mail: " "
  },
  cust_sliderValue: {
    sliderValue: 0,
    excludedCount: 0
  },
  cust_summaryDetails : {query_details : {condition: "", value: ""}, charts_details : {condition: "", value: ""}, segment_details : {condition: "", value: ""}, filter_tab_details : {condition: "", value: ""}, segments_tab_details : {condition: "", value: ""}}
  // cust_summaryDetails : ""
};
const reducer = (state = initialState, action) => {
  const newState = { ...state };
  switch (action.type) {
    case "Add":
      state = {
        ...state,
        count: state.count + 1
      };
      break;
    case "Add_SEGMENT":
      state = {
        ...state,
        countSegment: state.countSegment + 1
      };
      break;
    case "CLOSE_MODEL":
      state = {
        ...state,
        isModalOpen: action.payload
      };
      break;
    case "CLOSE_MODEL_SEGMENT":
      state = {
        ...state,
        isModalOpenSegment: action.payload
      };
      break;
    case "TILL_SQL_PUSH":
      if (action.selectedRule !== "") {
        state.tillSqlSelectionArr[action.selectedIndex][action.selectedRule] =
          action.payload;
      } else if (action.selectedIndex !== "no_index") {
        if (state.ruleLeveltoggle.hasOwnProperty(action.selectedIndex)) {
          state.ruleLeveltoggle[action.selectedIndex].push("AND");
        } else {
          state.ruleLeveltoggle[action.selectedIndex] = ["AND"];
        }
        state.tillSqlSelectionArr[action.selectedIndex].push(action.payload);
      } else {
        if (
          state.tillSqlSelectionArr.length > 0 &&
          state.groupLeveltoggle.length > 0
        ) {
          state.groupLeveltoggle[0].push("AND");
        } else if (state.tillSqlSelectionArr.length > 0) {
          if (state.groupLeveltoggle.length == 0) {
            state.groupLeveltoggle.push(["AND"]);
          } else {
            state.groupLeveltoggle[0].push("AND");
          }
        }
        state.tillSqlSelectionArr.push([action.payload]);
      }
      state = {
        ...state
      };
      break;
    case "TILL_SQL_PUSH_SEGMENT":
      if (action.selectedRule !== "") {
        state.tillSqlSelectionArrSegment[action.selectedIndex][
          action.selectedRule
        ] = action.payload;
      } else if (action.selectedIndex !== "no_index") {
        if (state.ruleLeveltoggleSegment.hasOwnProperty(action.selectedIndex)) {
          state.ruleLeveltoggleSegment[action.selectedIndex].push("AND");
        } else {
          state.ruleLeveltoggleSegment[action.selectedIndex] = ["AND"];
        }
        state.tillSqlSelectionArrSegment[action.selectedIndex].push(
          action.payload
        );
      } else {
        if (
          state.tillSqlSelectionArrSegment.length > 0 &&
          state.groupLeveltoggleSegment.length > 0
        ) {
          state.groupLeveltoggleSegment[0].push("AND");
        } else if (state.tillSqlSelectionArrSegment.length > 0) {
          if (state.groupLeveltoggleSegment.length == 0) {
            state.groupLeveltoggleSegment.push(["AND"]);
          } else {
            state.groupLeveltoggleSegment[0].push("AND");
          }
        }
        state.tillSqlSelectionArrSegment.push([action.payload]);
      }
      state = {
        ...state
      };
      break;
    case "AFTER_SQL_PUSH":
      if (action.selectedRule !== "") {
        state.afterSqlSelectionArr[action.selectedIndex][action.selectedRule] =
          action.payload[0];
      } else if (action.selectedIndex !== "no_index") {
        state.afterSqlSelectionArr[action.selectedIndex].push(
          action.payload[0]
        );
      } else {
        state.afterSqlSelectionArr.push(action.payload);
      }
      state = {
        ...state
      };
      break;
    case "AFTER_SQL_PUSH_SEGMENT":
      if (action.selectedRule !== "") {
        state.afterSqlSelectionArrSegment[action.selectedIndex][
          action.selectedRule
        ] = action.payload[0];
      } else if (action.selectedIndex !== "no_index") {
        state.afterSqlSelectionArrSegment[action.selectedIndex].push(
          action.payload[0]
        );
      } else {
        state.afterSqlSelectionArrSegment.push(action.payload);
      }
      state = {
        ...state
      };
      break;
    case "ADD_SEGMENT_NAME":
      state = {
        ...state
      };
      state.segmentName.push(action.payload);
      break;
    case "UPDATE_SEGMENT_NAME":
      state = {
        ...state
      };
      state.segmentName[action.selectedIndex] = action.payload
      break;
    case "REMOVE_SEGMENT_NAME":
      state = {
        ...state
      };
      var index = state.segmentName.indexOf("Remainder");
      if (index != -1) {
          state.segmentName.splice(index, 1);
      }
      state = {
        ...state
      };
      break;
    case "DELETE_SEGMENT":
      state = {
        ...state
      };
      if (action.payload != -1) {
          state.tillSqlSelectionArrSegment.splice(action.payload, 1);
          state.afterSqlSelectionArrSegment.splice(action.payload, 1);
          state.ruleLeveltoggleSegment.splice(action.payload, 1);
          state.segmentName.splice(action.payload, 1);
      }
      state = {
        ...state
      };
      break;
    case "TILL_SQL_POP":
      state.tillSqlSelectionArr[action.selectedIndex].splice(
        action.selectedRule,
        1
      );
      state.afterSqlSelectionArr[action.selectedIndex].splice(
        action.selectedRule,
        1
      );
      if (
        state.ruleLeveltoggle.length > 0 &&
        state.ruleLeveltoggle[action.selectedIndex] !== undefined &&
        state.ruleLeveltoggle[action.selectedIndex][action.selectedRule] !==
          undefined
      ) {
        state.ruleLeveltoggle[action.selectedIndex].splice(
          action.selectedRule,
          1
        );
        if (state.ruleLeveltoggle.length === 0) {
          state.ruleLeveltoggle = [];
        } else if (
          state.tillSqlSelectionArr[action.selectedIndex].length === 0
        ) {
          state.ruleLeveltoggle.splice(action.selectedIndex, 1);
        }
      } else if (
        state.ruleLeveltoggle.length > 0 &&
        state.ruleLeveltoggle[action.selectedIndex] !== undefined &&
        state.ruleLeveltoggle[action.selectedIndex].length ===
          action.selectedRule
      ) {
        
        if (
          state.ruleLeveltoggle[action.selectedIndex] !== undefined &&
          state.ruleLeveltoggle[action.selectedIndex].length === 0
        ) {
          state.ruleLeveltoggle.splice(action.selectedIndex, 1);
        } else {
          state.ruleLeveltoggle[action.selectedIndex].splice(
            action.selectedRule - 1,
            1
          );
        }
      } else if (state.ruleLeveltoggle.length === 0) {
        state.ruleLeveltoggle = [];
      }
      if (state.tillSqlSelectionArr[action.selectedIndex].length === 0) {
        if (state.groupLeveltoggle.length > 0) {
          if (
            state.groupLeveltoggle[0][action.selectedIndex - 1] !== undefined
          ) {
            state.groupLeveltoggle[0].splice(action.selectedIndex - 1, 1);
          } else {
            state.groupLeveltoggle[0].splice(action.selectedIndex - 1, 1);
          }
          if (state.groupLeveltoggle[0].length == 0) {
            state.groupLeveltoggle = [];
          }
        } else {
          state.groupLeveltoggle = [];
        }
        state.tillSqlSelectionArr.splice(action.selectedIndex, 1);
      }
      if (state.afterSqlSelectionArr[action.selectedIndex].length === 0) {
        state.afterSqlSelectionArr.splice(action.selectedIndex, 1);
      }

      if (state.tillSqlSelectionArr.length == 0) {
        state.queryCount = {
          query_count: " ",
          full_count: " ",
          address_count: " ",
          email_count: " ",
          total_audience_email_count: " ",
          total_audience_email_pre: " ",
          total_audience_email_eclub: " ",
          total_non_mkt: " ",
          total_mkt: " ",
          non_eclub_emails: " ", 
          non_preclub_emails: " ",
          non_email_custs: " ",
          non_direct_mail: " "
        };
        state.queryCountTempSegment = {
          query_count: " ",
          full_count: " ",
          address_count: " ",
          email_count: " ",
          total_audience_email_count: " ",
          total_audience_email_pre: " ",
          total_audience_email_eclub: " ",
          total_non_mkt: " ",
          total_mkt: " ",
          non_eclub_emails: " ", 
          non_preclub_emails: " ",
          non_email_custs: " ",
          non_direct_mail: " "
        };
      }
      state.count = state.count + 1;
      state = {
        ...state
      };
      break;
    case "TILL_SQL_POP_SEGMENT":
      let isSegmentDeleted = false;
      state.tillSqlSelectionArrSegment[action.selectedIndex].splice(
        action.selectedRule,
        1
      );
      state.afterSqlSelectionArrSegment[action.selectedIndex].splice(
        action.selectedRule,
        1
      );
      if (
        state.ruleLeveltoggleSegment.length > 0 &&
        state.ruleLeveltoggleSegment[action.selectedIndex] !== undefined &&
        state.ruleLeveltoggleSegment[action.selectedIndex][
          action.selectedRule
        ] !== undefined
      ) {
        state.ruleLeveltoggleSegment[action.selectedIndex].splice(
          action.selectedRule,
          1
        );
        if (state.ruleLeveltoggleSegment.length === 0) {
          state.ruleLeveltoggleSegment = [];
        } else if (
          state.tillSqlSelectionArrSegment[action.selectedIndex].length === 0
        ) {
          state.ruleLeveltoggleSegment.splice(action.selectedIndex, 1);
        }
      } else if (
        state.ruleLeveltoggleSegment.length > 0 &&
        state.ruleLeveltoggleSegment[action.selectedIndex] !== undefined &&
        state.ruleLeveltoggleSegment[action.selectedIndex].length ===
          action.selectedRule
      ) {
        if (
          state.ruleLeveltoggleSegment[action.selectedIndex] !== undefined &&
          state.ruleLeveltoggleSegment[action.selectedIndex].length === 0
        ) {
          if (isSegmentDeleted === false) {
            state.segmentName.splice(action.selectedIndex, 1);
            isSegmentDeleted = true;
          }
          state.ruleLeveltoggleSegment.splice(action.selectedIndex, 1);
        } else {
          state.ruleLeveltoggleSegment[action.selectedIndex].splice(
            action.selectedRule - 1,
            1
          );
        }
      } else if (state.ruleLeveltoggleSegment.length === 0) {
        state.ruleLeveltoggleSegment = [];
        if (isSegmentDeleted === false) {
          state.segmentName.splice(action.selectedIndex, 1);
          isSegmentDeleted = true;
        }
      }
      if (state.tillSqlSelectionArrSegment[action.selectedIndex].length === 0) {
        if (state.groupLeveltoggleSegment.length > 0) {
          if (
            state.groupLeveltoggleSegment[0][action.selectedIndex - 1] !==
            undefined
          ) {
            state.groupLeveltoggleSegment[0].splice(
              action.selectedIndex - 1,
              1
            );
            if (isSegmentDeleted === false) {
              state.segmentName.splice(action.selectedIndex, 1);
              isSegmentDeleted = true;
            }
          } else {
            state.groupLeveltoggleSegment[0].splice(
              action.selectedIndex - 1,
              1
            );
          }
          if (state.groupLeveltoggleSegment[0].length == 0) {
            state.groupLeveltoggleSegment = [];
          }
        } else {
          state.groupLeveltoggleSegment = [];
          state.segmentName = [];
        }
        state.tillSqlSelectionArrSegment.splice(action.selectedIndex, 1);
      }
      if (
        state.afterSqlSelectionArrSegment[action.selectedIndex].length === 0
      ) {
        state.afterSqlSelectionArrSegment.splice(action.selectedIndex, 1);
      }

      if (state.tillSqlSelectionArrSegment.length == 0) {
        state.queryCountSegment = {
          query_count: " ",
          full_count: " ",
          address_count: " ",
          email_count: " ",
          total_audience_email_count: " ",
          total_audience_email_pre: " ",
          total_audience_email_eclub: " ",
          total_non_mkt: " ",
          total_mkt: " ",
          non_eclub_emails: " ", 
          non_preclub_emails: " ",
          non_email_custs: " ",
          non_direct_mail: " "
        };
      }
      state.countSegment = state.countSegment + 1;
      state = {
        ...state
      };
      break;
    case "ADD_GROUP_LEVEL_TOGGLE":
      if (action.selectedRule !== "") {
        state.groupLeveltoggle[action.selectedIndex][action.selectedRule] =
          action.payload;
      } else if (action.selectedIndex !== "no_index") {
        state.groupLeveltoggle[0][action.selectedIndex] = action.payload;
      } else {
        state.groupLeveltoggle.push([action.payload]);
      }
      state = {
        ...state
      };
      break;
    case "ADD_GROUP_LEVEL_TOGGLE_SEGMENT":
      if (action.selectedRule !== "") {
        state.groupLeveltoggleSegment[action.selectedIndex][
          action.selectedRule
        ] = action.payload;
      } else if (action.selectedIndex !== "no_index") {
        state.groupLeveltoggleSegment[0][action.selectedIndex] = action.payload;
      } else {
        state.groupLeveltoggleSegment.push([action.payload]);
      }
      state = {
        ...state
      };
      break;
    case "ADD_RULE_LEVEL_TOGGLE":
      if (action.selectedRule !== "") {
        state.ruleLeveltoggle[action.selectedIndex][action.selectedRule] =
          action.payload;
      } else if (action.selectedIndex !== "no_index") {
        state.ruleLeveltoggle[action.selectedIndex].push(action.payload);
      } else {
        state.ruleLeveltoggle.push([action.payload]);
      }
      state = {
        ...state
      };
      break;
    case "ADD_RULE_LEVEL_TOGGLE_SEGMENT":
      if (action.selectedRule !== "") {
        state.ruleLeveltoggleSegment[action.selectedIndex][
          action.selectedRule
        ] = action.payload;
      } else if (action.selectedIndex !== "no_index") {
        state.ruleLeveltoggleSegment[action.selectedIndex].push(action.payload);
      } else {
        state.ruleLeveltoggleSegment.push([action.payload]);
      }
      state = {
        ...state
      };
      break;
    case "POP_GROUP_LEVEL_TOGGLE":
      state = {
        ...state
      };
      state.groupLeveltoggle.pop();
      break;
    case "POP_GROUP_LEVEL_TOGGLE_SEGMENT":
      state = {
        ...state
      };
      state.groupLeveltoggleSegment.pop();
      break;
    case "UPDATE_QUERY_COUNT":
      state = {
        ...state
      };
      state.showQuerySpinner = "no";
      state.queryCount = {
        query_count: action.query_count,
        full_count: action.full_count,
        address_count: action.address_count,
        email_count: action.email_count,
        total_audience_email_count : action.total_audience_email_count,
        total_audience_email_pre: action.total_audience_email_pre,
        total_audience_email_eclub: action.total_audience_email_eclub,
        total_non_mkt: action.total_non_mkt,
        total_mkt: action.total_mkt,
        non_eclub_emails: action.non_eclub_emails, 
        non_preclub_emails: action.non_preclub_emails,
        non_email_custs: action.non_email_custs,
        non_direct_mail: action.non_direct_mail
      };
      state.queryCountTempSegment = {
        query_count: action.query_count,
        full_count: action.full_count,
        address_count: action.address_count,
        email_count: action.email_count,
        total_audience_email_count : action.total_audience_email_count,
        total_audience_email_pre: action.total_audience_email_pre,
        total_audience_email_eclub: action.total_audience_email_eclub,
        total_non_mkt: action.total_non_mkt,
        total_mkt: action.total_mkt,
        non_eclub_emails: action.non_eclub_emails, 
        non_preclub_emails: action.non_preclub_emails,
        non_email_custs: action.non_email_custs,
        non_direct_mail: action.non_direct_mail
      };
      state.previewData = [];
      state.previewData.push(action.preview);
      break;
    case "UPDATE_QUERY_COUNT_SEGMENT":
      state = {
        ...state
      };
      state.showQuerySpinnerSegment = "no";
      state.segmentData = action.segmentData;
      state = {
        ...state
      };
      break;
    case "EDIT_AUDIENCE":
      state = {
        ...state
      };
      state.count = 0;
      state.tillSqlSelectionArr = [];
      state.afterSqlSelectionArr = [];
      state.groupLeveltoggle = [];
      state.ruleLeveltoggle = [];
      state.isModalOpen = "";
      state.queryCount = {
        query_count: " ",
        full_count: " ",
        address_count: " ",
        email_count: " "
      };
      state.queryCountTempSegment = {
        query_count: " ",
        full_count: " ",
        address_count: " ",
        email_count: " ",
        total_audience_email_count : " ",
        total_audience_email_pre: " ",
        total_audience_email_eclub: " ",
        total_non_mkt: " ",
        total_mkt: " ",
        non_eclub_emails: " ", 
        non_preclub_emails: " ",
        non_email_custs: " ",
        non_direct_mail: " "
      };
      if (action.tillSqlSelectionArr != "") {
        state.tillSqlSelectionArr = action.tillSqlSelectionArr;
      }
      if (action.afterSqlSelectionArr != "") {
        state.afterSqlSelectionArr = action.afterSqlSelectionArr;
      }
      if (action.ruleLeveltoggle != "") {
        state.ruleLeveltoggle = action.ruleLeveltoggle;
      }
      if (action.groupLeveltoggle != "") {
        state.groupLeveltoggle = action.groupLeveltoggle;
      }
      state.sliderValue = {sliderValue : 0, excludedCount: 0};
      state.summaryDetails = {query_details : {condition: "", value: ""}, charts_details : {condition: "", value: ""}, segment_details : {condition: "", value: ""}, filter_tab_details : {condition: "", value: ""}, segments_tab_details : {condition: "", value: ""}}
      state = {
        ...state
      };
      break;
    case "EDIT_AUDIENCE_SEGMENT":
      state = {
        ...state
      };
      state.countSegment = 0;
      state.tillSqlSelectionArrSegment = [];
      state.afterSqlSelectionArrSegment = [];
      state.groupLeveltoggleSegment = [];
      state.ruleLeveltoggleSegment = [];
      state.isModalOpenSegment = "";
      state.segmentName = [];
      state.segmentData = [];
      state.queryCountSegment = {
        query_count: " ",
        full_count: " ",
        address_count: " ",
        email_count: " ",
        total_audience_email_count : " ",
        total_audience_email_pre: " ",
        total_audience_email_eclub: " ",
        total_non_mkt: " ",
        total_mkt: " ",
        non_eclub_emails: " ", 
        non_preclub_emails: " ",
        non_email_custs: " ",
        non_direct_mail: " "
      };
      if (action.tillSqlSelectionArrSegment != "") {
        state.tillSqlSelectionArrSegment = action.tillSqlSelectionArrSegment;
      }
      if (action.afterSqlSelectionArrSegment != "") {
        state.afterSqlSelectionArrSegment = action.afterSqlSelectionArrSegment;
      }
      if (action.ruleLeveltoggleSegment != "") {
        state.ruleLeveltoggleSegment = action.ruleLeveltoggleSegment;
      }
      if (action.groupLeveltoggleSegment != "") {
        state.groupLeveltoggleSegment = action.groupLeveltoggleSegment;
      }
      if (action.segmentName != "") {
        state.segmentName = action.segmentName;
      }
      state = {
        ...state
      };
      break;
    case "SHOW_SPINNER":
      state = {
        ...state
      };
      state.showQuerySpinner = "yes";
      state.previewData = [];
      break;
    case "SHOW_SPINNER_SEGMENT":
      state = {
        ...state
      };
      state.showQuerySpinnerSegment = "yes";
      // state.previewDataSegment = [];
      break;
    case "SHOW_TABS":
      state = {
        ...state
      };
      state.hideTabs = action.payload;
      break;
    case "CUSTOM_QUERY_COUNT":
      state = {
        ...state
      };
      state.queryCountTempSegment = {
        query_count: action.query_count,
        full_count: action.full_count,
        address_count: action.address_count,
        email_count: action.email_count,
        total_audience_email_count : action.total_audience_email_count,
        total_audience_email_pre: action.total_audience_email_pre,
        total_audience_email_eclub: action.total_audience_email_eclub,
        total_non_mkt: action.total_non_mkt,
        total_mkt: action.total_mkt,
        non_eclub_emails: action.non_eclub_emails, 
        non_preclub_emails: action.non_preclub_emails,
        non_email_custs: action.non_email_custs,
        non_direct_mail: action.non_direct_mail
      };
      // state.previewData = [];
      // state.previewData.push(action.preview);
      state = {
        ...state
      };
      break;
    case "CHANGE_SLIDER_VALUE":
      state = {
        ...state
      };
      state.sliderValue = {
        sliderValue: action.payload,
        excludedCount: action.excludedCount,
      }
      state = {
        ...state
      };
      break;
    case "UPDATE_SUMMARY_DETAILS":
      state = {
        ...state
      };

      if (action.queryPayload !== undefined) {
        state.summaryDetails['query_details']['condition'] = action.queryPayload,
        state.summaryDetails['query_details']['value'] = action.queryValue
      }

      if (action.chartsPayload !== undefined) {
        state.summaryDetails['charts_details']['condition'] = action.chartsPayload,
        state.summaryDetails['charts_details']['value'] = action.chartsValue
      }

      if (action.segmentPayload !== undefined) {
        state.summaryDetails['segment_details']['condition'] = action.segmentPayload,
        state.summaryDetails['segment_details']['value'] = action.segmentValue
      }

      if (action.filterTabPayload !== undefined) {
        state.summaryDetails['filter_tab_details']['condition'] = action.filterTabPayload,
        state.summaryDetails['filter_tab_details']['value'] = action.filterTabValue
      }

      if (action.segmentsTabPayload !== undefined) {
        state.summaryDetails['segments_tab_details']['condition'] = action.segmentsTabPayload,
        state.summaryDetails['segments_tab_details']['value'] = action.segmentsTabValue
      }
      state = {
        ...state
      };
      break;
      case "CUST_Add":
        state = {
          ...state,
          cust_count: state.cust_count + 1
        };
        break;
      case "CUST_Add_SEGMENT":
        state = {
          ...state,
          cust_countSegment: state.cust_countSegment + 1
        };
        break;
      case "CUST_CLOSE_MODEL":
        state = {
          ...state,
          cust_isModalOpen: action.payload
        };
        break;
      case "CUST_CLOSE_MODEL_SEGMENT":
        state = {
          ...state,
          cust_isModalOpenSegment: action.payload
        };
        break;
      case "CUST_TILL_SQL_PUSH":
        if (action.selectedRule !== "") {
          state.cust_tillSqlSelectionArr[action.selectedIndex][action.selectedRule] =
            action.payload;
        } else if (action.selectedIndex !== "no_index") {
          if (state.cust_ruleLeveltoggle.hasOwnProperty(action.selectedIndex)) {
            state.cust_ruleLeveltoggle[action.selectedIndex].push("AND");
          } else {
            state.cust_ruleLeveltoggle[action.selectedIndex] = ["AND"];
          }
          state.cust_tillSqlSelectionArr[action.selectedIndex].push(action.payload);
        } else {
          if (
            state.cust_tillSqlSelectionArr.length > 0 &&
            state.cust_groupLeveltoggle.length > 0
          ) {
            state.cust_groupLeveltoggle[0].push("AND");
          } else if (state.cust_tillSqlSelectionArr.length > 0) {
            if (state.cust_groupLeveltoggle.length == 0) {
              state.cust_groupLeveltoggle.push(["AND"]);
            } else {
              state.cust_groupLeveltoggle[0].push("AND");
            }
          }
          state.cust_tillSqlSelectionArr.push([action.payload]);
        }
        state = {
          ...state
        };
        break;
      case "CUST_TILL_SQL_PUSH_SEGMENT":
        if (action.selectedRule !== "") {
          state.cust_tillSqlSelectionArrSegment[action.selectedIndex][
            action.selectedRule
          ] = action.payload;
        } else if (action.selectedIndex !== "no_index") {
          if (state.cust_ruleLeveltoggleSegment.hasOwnProperty(action.selectedIndex)) {
            state.cust_ruleLeveltoggleSegment[action.selectedIndex].push("AND");
          } else {
            state.cust_ruleLeveltoggleSegment[action.selectedIndex] = ["AND"];
          }
          state.cust_tillSqlSelectionArrSegment[action.selectedIndex].push(
            action.payload
          );
        } else {
          if (
            state.cust_tillSqlSelectionArrSegment.length > 0 &&
            state.cust_groupLeveltoggleSegment.length > 0
          ) {
            state.cust_groupLeveltoggleSegment[0].push("AND");
          } else if (state.cust_tillSqlSelectionArrSegment.length > 0) {
            if (state.cust_groupLeveltoggleSegment.length == 0) {
              state.cust_groupLeveltoggleSegment.push(["AND"]);
            } else {
              state.cust_groupLeveltoggleSegment[0].push("AND");
            }
          }
          state.cust_tillSqlSelectionArrSegment.push([action.payload]);
        }
        state = {
          ...state
        };
        break;
      case "CUST_AFTER_SQL_PUSH":
        if (action.selectedRule !== "") {
          state.cust_afterSqlSelectionArr[action.selectedIndex][action.selectedRule] =
            action.payload[0];
        } else if (action.selectedIndex !== "no_index") {
          state.cust_afterSqlSelectionArr[action.selectedIndex].push(
            action.payload[0]
          );
        } else {
          state.cust_afterSqlSelectionArr.push(action.payload);
        }
        state = {
          ...state
        };
        break;
      case "CUST_AFTER_SQL_PUSH_SEGMENT":
        if (action.selectedRule !== "") {
          state.cust_afterSqlSelectionArrSegment[action.selectedIndex][
            action.selectedRule
          ] = action.payload[0];
        } else if (action.selectedIndex !== "no_index") {
          state.cust_afterSqlSelectionArrSegment[action.selectedIndex].push(
            action.payload[0]
          );
        } else {
          state.cust_afterSqlSelectionArrSegment.push(action.payload);
        }
        state = {
          ...state
        };
        break;
      case "CUST_ADD_SEGMENT_NAME":
        state = {
          ...state
        };
        state.cust_segmentName.push(action.payload);
        break;
      case "CUST_UPDATE_SEGMENT_NAME":
        state = {
          ...state
        };
        state.cust_segmentName[action.selectedIndex] = action.payload
        break;
      case "CUST_REMOVE_SEGMENT_NAME":
        state = {
          ...state
        };
        var index = state.cust_segmentName.indexOf("Remainder");
        if (index != -1) {
            state.cust_segmentName.splice(index, 1);
        }
        state = {
          ...state
        };
        break;
      case "CUST_DELETE_SEGMENT":
        state = {
          ...state
        };
        if (action.payload != -1) {
            state.cust_tillSqlSelectionArrSegment.splice(action.payload, 1);
            state.cust_afterSqlSelectionArrSegment.splice(action.payload, 1);
            state.cust_ruleLeveltoggleSegment.splice(action.payload, 1);
            state.cust_segmentName.splice(action.payload, 1);
        }
        state = {
          ...state
        };
        break;
      case "CUST_TILL_SQL_POP":
        state.cust_tillSqlSelectionArr[action.selectedIndex].splice(
          action.selectedRule,
          1
        );
        state.cust_afterSqlSelectionArr[action.selectedIndex].splice(
          action.selectedRule,
          1
        );
        if (
          state.cust_ruleLeveltoggle.length > 0 &&
          state.cust_ruleLeveltoggle[action.selectedIndex] !== undefined &&
          state.cust_ruleLeveltoggle[action.selectedIndex][action.selectedRule] !==
            undefined
        ) {
          state.cust_ruleLeveltoggle[action.selectedIndex].splice(
            action.selectedRule,
            1
          );
          if (state.cust_ruleLeveltoggle.length === 0) {
            state.cust_ruleLeveltoggle = [];
          } else if (
            state.cust_tillSqlSelectionArr[action.selectedIndex].length === 0
          ) {
            state.cust_ruleLeveltoggle.splice(action.selectedIndex, 1);
          }
        } else if (
          state.cust_ruleLeveltoggle.length > 0 &&
          state.cust_ruleLeveltoggle[action.selectedIndex] !== undefined &&
          state.cust_ruleLeveltoggle[action.selectedIndex].length ===
            action.selectedRule
        ) {
          
          if (
            state.cust_ruleLeveltoggle[action.selectedIndex] !== undefined &&
            state.cust_ruleLeveltoggle[action.selectedIndex].length === 0
          ) {
            state.cust_ruleLeveltoggle.splice(action.selectedIndex, 1);
          } else {
            state.cust_ruleLeveltoggle[action.selectedIndex].splice(
              action.selectedRule - 1,
              1
            );
          }
        } else if (state.cust_ruleLeveltoggle.length === 0) {
          state.cust_ruleLeveltoggle = [];
        }
        if (state.cust_tillSqlSelectionArr[action.selectedIndex].length === 0) {
          if (state.cust_groupLeveltoggle.length > 0) {
            if (
              state.cust_groupLeveltoggle[0][action.selectedIndex - 1] !== undefined
            ) {
              state.cust_groupLeveltoggle[0].splice(action.selectedIndex - 1, 1);
            } else {
              state.cust_groupLeveltoggle[0].splice(action.selectedIndex - 1, 1);
            }
            if (state.cust_groupLeveltoggle[0].length == 0) {
              state.cust_groupLeveltoggle = [];
            }
          } else {
            state.cust_groupLeveltoggle = [];
          }
          state.cust_tillSqlSelectionArr.splice(action.selectedIndex, 1);
        }
        if (state.cust_afterSqlSelectionArr[action.selectedIndex].length === 0) {
          state.cust_afterSqlSelectionArr.splice(action.selectedIndex, 1);
        }
  
        if (state.cust_tillSqlSelectionArr.length == 0) {
          state.cust_queryCount = {
            query_count: " ",
            full_count: " ",
            address_count: " ",
            email_count: " ",
            total_audience_email_count : " ",
            total_audience_email_pre: " ",
            total_audience_email_eclub: " ",
            total_non_mkt: " ",
            total_mkt: " ",
            non_eclub_emails: " ", 
            non_preclub_emails: " ",
            non_email_custs: " ",
            non_direct_mail: " "
          };
          state.cust_queryCountTempSegment = {
            query_count: " ",
            full_count: " ",
            address_count: " ",
            email_count: " ",
            total_audience_email_count : " ",
            total_audience_email_pre: " ",
            total_audience_email_eclub: " ",
            total_non_mkt: " ",
            total_mkt: " ",
            non_eclub_emails: " ", 
            non_preclub_emails: " ",
            non_email_custs: " ",
            non_direct_mail: " "
          };
        }
        state.cust_count = state.cust_count + 1;
        state = {
          ...state
        };
        break;
      case "CUST_TILL_SQL_POP_SEGMENT":
        isSegmentDeleted = false;
        state.cust_tillSqlSelectionArrSegment[action.selectedIndex].splice(
          action.selectedRule,
          1
        );
        state.cust_afterSqlSelectionArrSegment[action.selectedIndex].splice(
          action.selectedRule,
          1
        );
        if (
          state.cust_ruleLeveltoggleSegment.length > 0 &&
          state.cust_ruleLeveltoggleSegment[action.selectedIndex] !== undefined &&
          state.cust_ruleLeveltoggleSegment[action.selectedIndex][
            action.selectedRule
          ] !== undefined
        ) {
          state.cust_ruleLeveltoggleSegment[action.selectedIndex].splice(
            action.selectedRule,
            1
          );
          if (state.cust_ruleLeveltoggleSegment.length === 0) {
            state.cust_ruleLeveltoggleSegment = [];
          } else if (
            state.cust_tillSqlSelectionArrSegment[action.selectedIndex].length === 0
          ) {
            state.cust_ruleLeveltoggleSegment.splice(action.selectedIndex, 1);
          }
        } else if (
          state.cust_ruleLeveltoggleSegment.length > 0 &&
          state.cust_ruleLeveltoggleSegment[action.selectedIndex] !== undefined &&
          state.cust_ruleLeveltoggleSegment[action.selectedIndex].length ===
            action.selectedRule
        ) {
          if (
            state.cust_ruleLeveltoggleSegment[action.selectedIndex] !== undefined &&
            state.cust_ruleLeveltoggleSegment[action.selectedIndex].length === 0
          ) {
            if (isSegmentDeleted === false) {
              state.cust_segmentName.splice(action.selectedIndex, 1);
              isSegmentDeleted = true;
            }
            state.cust_ruleLeveltoggleSegment.splice(action.selectedIndex, 1);
          } else {
            state.cust_ruleLeveltoggleSegment[action.selectedIndex].splice(
              action.selectedRule - 1,
              1
            );
          }
        } else if (state.cust_ruleLeveltoggleSegment.length === 0) {
          state.cust_ruleLeveltoggleSegment = [];
          if (isSegmentDeleted === false) {
            state.cust_segmentName.splice(action.selectedIndex, 1);
            isSegmentDeleted = true;
          }
        }
        if (state.cust_tillSqlSelectionArrSegment[action.selectedIndex].length === 0) {
          if (state.cust_groupLeveltoggleSegment.length > 0) {
            if (
              state.cust_groupLeveltoggleSegment[0][action.selectedIndex - 1] !==
              undefined
            ) {
              state.cust_groupLeveltoggleSegment[0].splice(
                action.selectedIndex - 1,
                1
              );
              if (isSegmentDeleted === false) {
                state.cust_segmentName.splice(action.selectedIndex, 1);
                isSegmentDeleted = true;
              }
            } else {
              state.cust_groupLeveltoggleSegment[0].splice(
                action.selectedIndex - 1,
                1
              );
            }
            if (state.cust_groupLeveltoggleSegment[0].length == 0) {
              state.cust_groupLeveltoggleSegment = [];
            }
          } else {
            state.cust_groupLeveltoggleSegment = [];
            state.cust_segmentName = [];
          }
          state.cust_tillSqlSelectionArrSegment.splice(action.selectedIndex, 1);
        }
        if (
          state.cust_afterSqlSelectionArrSegment[action.selectedIndex].length === 0
        ) {
          state.cust_afterSqlSelectionArrSegment.splice(action.selectedIndex, 1);
        }
  
        if (state.cust_tillSqlSelectionArrSegment.length == 0) {
          state.cust_queryCountSegment = {
            query_count: " ",
            full_count: " ",
            address_count: " ",
            email_count: " ",
            total_audience_email_count : " ",
            total_audience_email_pre: " ",
            total_audience_email_eclub: " ",
            total_non_mkt: " ",
            total_mkt: " ",
            non_eclub_emails: " ", 
            non_preclub_emails: " ",
            non_email_custs: " ",
            non_direct_mail: " "
          };
        }
        state.cust_countSegment = state.cust_countSegment + 1;
        state = {
          ...state
        };
        break;
      case "CUST_ADD_GROUP_LEVEL_TOGGLE":
        if (action.selectedRule !== "") {
          state.cust_groupLeveltoggle[action.selectedIndex][action.selectedRule] =
            action.payload;
        } else if (action.selectedIndex !== "no_index") {
          state.cust_groupLeveltoggle[0][action.selectedIndex] = action.payload;
        } else {
          state.cust_groupLeveltoggle.push([action.payload]);
        }
        state = {
          ...state
        };
        break;
      case "CUST_ADD_GROUP_LEVEL_TOGGLE_SEGMENT":
        if (action.selectedRule !== "") {
          state.cust_groupLeveltoggleSegment[action.selectedIndex][
            action.selectedRule
          ] = action.payload;
        } else if (action.selectedIndex !== "no_index") {
          state.cust_groupLeveltoggleSegment[0][action.selectedIndex] = action.payload;
        } else {
          state.cust_groupLeveltoggleSegment.push([action.payload]);
        }
        state = {
          ...state
        };
        break;
      case "CUST_ADD_RULE_LEVEL_TOGGLE":
        if (action.selectedRule !== "") {
          state.cust_ruleLeveltoggle[action.selectedIndex][action.selectedRule] =
            action.payload;
        } else if (action.selectedIndex !== "no_index") {
          state.cust_ruleLeveltoggle[action.selectedIndex].push(action.payload);
        } else {
          state.cust_ruleLeveltoggle.push([action.payload]);
        }
        state = {
          ...state
        };
        break;
      case "CUST_ADD_RULE_LEVEL_TOGGLE_SEGMENT":
        if (action.selectedRule !== "") {
          state.cust_ruleLeveltoggleSegment[action.selectedIndex][
            action.selectedRule
          ] = action.payload;
        } else if (action.selectedIndex !== "no_index") {
          state.cust_ruleLeveltoggleSegment[action.selectedIndex].push(action.payload);
        } else {
          state.cust_ruleLeveltoggleSegment.push([action.payload]);
        }
        state = {
          ...state
        };
        break;
      case "CUST_POP_GROUP_LEVEL_TOGGLE":
        state = {
          ...state
        };
        state.cust_groupLeveltoggle.pop();
        break;
      case "CUST_POP_GROUP_LEVEL_TOGGLE_SEGMENT":
        state = {
          ...state
        };
        state.cust_groupLeveltoggleSegment.pop();
        break;
        case "CUST_UPDATE_QUERY_RESULT_JSON":
          state = {
            ...state
          }
          state.cust_showQuerySpinner = "no";
          state.filter_result_json = action.filter_result_json
          state.cust_queryCountTempSegment = {
            query_count: action.query_count,
            full_count: action.full_count,
            address_count: action.address_count,
            email_count: action.email_count,
            total_audience_email_count : action.total_audience_email_count,
            total_audience_email_pre: action.total_audience_email_pre,
            total_audience_email_eclub: action.total_audience_email_eclub,
            total_non_mkt: action.total_non_mkt,
            total_mkt: action.total_mkt,
            non_eclub_emails: action.non_eclub_emails, 
            non_preclub_emails: action.non_preclub_emails,
            non_email_custs: action.non_email_custs,
            non_direct_mail: action.non_direct_mail
          };
          state.cust_previewData = [];
          state.cust_previewData.push(action.preview);
          break;
      
      case "CUST_UPDATE_OVERLAY_SPINNER":
            state = {
              ...state
            }
            state.overlaySpinner = action.overlaySpinner
            break;

      case "CUST_UPDATE_QUERY_COUNT":
        state = {
          ...state
        };
        state.cust_showQuerySpinner = "no";
        state.cust_queryCount = {
          query_count: action.query_count,
          full_count: action.full_count,
          address_count: action.address_count,
          email_count: action.email_count,
          total_audience_email_count : action.total_audience_email_count,
          total_audience_email_pre: action.total_audience_email_pre,
          total_audience_email_eclub: action.total_audience_email_eclub,
          total_non_mkt: action.total_non_mkt,
          total_mkt: action.total_mkt,
          non_eclub_emails: action.non_eclub_emails, 
          non_preclub_emails: action.non_preclub_emails,
          non_email_custs: action.non_email_custs,
          non_direct_mail: action.non_direct_mail

        };
        state.cust_queryCountTempSegment = {
          query_count: action.query_count,
          full_count: action.full_count,
          address_count: action.address_count,
          email_count: action.email_count,
          total_audience_email_count : action.total_audience_email_count,
          total_audience_email_pre: action.total_audience_email_pre,
          total_audience_email_eclub: action.total_audience_email_eclub,
          total_non_mkt: action.total_non_mkt,
          total_mkt: action.total_mkt,
          non_eclub_emails: action.non_eclub_emails, 
          non_preclub_emails: action.non_preclub_emails,
          non_email_custs: action.non_email_custs,
          non_direct_mail: action.non_direct_mail
        };
        state.cust_previewData = [];
        state.cust_previewData.push(action.preview);
        break;
      case "CUST_UPDATE_QUERY_COUNT_SEGMENT":
        state = {
          ...state
        };
        state.cust_showQuerySpinnerSegment = "no";
        state.cust_segmentData = action.segmentData;
        state = {
          ...state
        };
        break;
      case "CUST_EDIT_AUDIENCE":
        state = {
          ...state
        };
        state.cust_count = 0;
        state.cust_tillSqlSelectionArr = [];
        state.cust_afterSqlSelectionArr = [];
        state.cust_groupLeveltoggle = [];
        state.cust_ruleLeveltoggle = [];
        state.cust_isModalOpen = "";
        state.cust_queryCount = {
          query_count: " ",
          full_count: " ",
          address_count: " ",
          email_count: " ",
          total_audience_email_count : " ",
          total_audience_email_pre: " ",
          total_audience_email_eclub: " ",
          total_non_mkt: " ",
          total_mkt: " ",
          non_eclub_emails: " ", 
          non_preclub_emails: " ",
          non_email_custs: " ",
          non_direct_mail: " "
        };
        state.cust_queryCountTempSegment = {
          query_count: " ",
          full_count: " ",
          address_count: " ",
          email_count: " ",
          total_audience_email_count : " ",
          total_audience_email_pre: " ",
          total_audience_email_eclub: " ",
          total_non_mkt: " ",
          total_mkt: " ",
          non_eclub_emails: " ", 
          non_preclub_emails: " ",
          non_email_custs: " ",
          non_direct_mail: " "
        };
        if (action.cust_tillSqlSelectionArr != "") {
          state.cust_tillSqlSelectionArr = action.cust_tillSqlSelectionArr;
        }
        if (action.cust_afterSqlSelectionArr != "") {
          state.cust_afterSqlSelectionArr = action.cust_afterSqlSelectionArr;
        }
        if (action.cust_ruleLeveltoggle != "") {
          state.cust_ruleLeveltoggle = action.cust_ruleLeveltoggle;
        }
        if (action.cust_groupLeveltoggle != "") {
          state.cust_groupLeveltoggle = action.cust_groupLeveltoggle;
        }
        state.cust_sliderValue = {sliderValue : 0, excludedCount: 0};
        state.cust_summaryDetails = {query_details : {condition: "", value: ""}, charts_details : {condition: "", value: ""}, segment_details : {condition: "", value: ""}, filter_tab_details : {condition: "", value: ""}, segments_tab_details : {condition: "", value: ""}}
        state = {
          ...state
        };
        break;
      case "CUST_EDIT_AUDIENCE_SEGMENT":
        state = {
          ...state
        };
        state.cust_countSegment = 0;
        state.cust_tillSqlSelectionArrSegment = [];
        state.cust_afterSqlSelectionArrSegment = [];
        state.cust_groupLeveltoggleSegment = [];
        state.cust_ruleLeveltoggleSegment = [];
        state.cust_isModalOpenSegment = "";
        state.cust_segmentName = [];
        state.cust_segmentData = [];
        state.cust_queryCountSegment = {
          query_count: " ",
          full_count: " ",
          address_count: " ",
          email_count: " ",
          total_audience_email_count : " ",
          total_audience_email_pre: " ",
          total_audience_email_eclub: " ",
          total_non_mkt: " ",
          total_mkt: " ",
          non_eclub_emails: " ", 
          non_preclub_emails: " ",
          non_email_custs: " ",
          non_direct_mail: " "
        };
        if (action.cust_tillSqlSelectionArrSegment != "") {
          state.cust_tillSqlSelectionArrSegment = action.cust_tillSqlSelectionArrSegment;
        }
        if (action.cust_afterSqlSelectionArrSegment != "") {
          state.cust_afterSqlSelectionArrSegment = action.cust_afterSqlSelectionArrSegment;
        }
        if (action.cust_ruleLeveltoggleSegment != "") {
          state.cust_ruleLeveltoggleSegment = action.cust_ruleLeveltoggleSegment;
        }
        if (action.cust_groupLeveltoggleSegment != "") {
          state.cust_groupLeveltoggleSegment = action.cust_groupLeveltoggleSegment;
        }
        if (action.cust_segmentName != "") {
          state.cust_segmentName = action.cust_segmentName;
        }
        state = {
          ...state
        };
        break;
      case "CUST_SHOW_SPINNER":
        state = {
          ...state
        };
        state.cust_showQuerySpinner = "yes";
        state.cust_previewData = [];
        break;
      case "CUST_SHOW_SPINNER_SEGMENT":
        state = {
          ...state
        };
        state.cust_showQuerySpinnerSegment = "yes";
        // state.cust_previewDataSegment = [];
        break;
      case "CUST_SHOW_TABS":
        state = {
          ...state
        };
        state.cust_hideTabs = action.payload;
        break;
      case "CUST_CUSTOM_QUERY_COUNT":
        state = {
          ...state
        };
        state.cust_queryCountTempSegment = {
          query_count: action.query_count,
          full_count: action.full_count,
          address_count: action.address_count,
          email_count: action.email_count,
          total_audience_email_count : " ",
          total_audience_email_pre: " ",
          total_audience_email_eclub: " ",
          total_non_mkt: " ",
          total_mkt: " ",
          non_eclub_emails: " ", 
          non_preclub_emails: " ",
          non_email_custs: " ",
          non_direct_mail: " "
        };
        // state.cust_previewData = [];
        // state.cust_previewData.push(action.preview);
        state = {
          ...state
        };
        break;
      case "CUST_CHANGE_SLIDER_VALUE":
        state = {
          ...state
        };
        state.cust_sliderValue = {
          sliderValue: action.payload,
          excludedCount: action.excludedCount,
        }
        state = {
          ...state
        };
        break;
      case "CUST_UPDATE_SUMMARY_DETAILS":
        state = {
          ...state
        };
  
        if (action.queryPayload !== undefined) {
          state.cust_summaryDetails['query_details']['condition'] = action.queryPayload,
          state.cust_summaryDetails['query_details']['value'] = action.queryValue
        }
  
        if (action.chartsPayload !== undefined) {
          state.cust_summaryDetails['charts_details']['condition'] = action.chartsPayload,
          state.cust_summaryDetails['charts_details']['value'] = action.chartsValue
        }
  
        if (action.segmentPayload !== undefined) {
          state.cust_summaryDetails['segment_details']['condition'] = action.segmentPayload,
          state.cust_summaryDetails['segment_details']['value'] = action.segmentValue
        }
  
        if (action.filterTabPayload !== undefined) {
          state.cust_summaryDetails['filter_tab_details']['condition'] = action.filterTabPayload,
          state.cust_summaryDetails['filter_tab_details']['value'] = action.filterTabValue
        }
  
        if (action.segmentsTabPayload !== undefined) {
          state.cust_summaryDetails['segments_tab_details']['condition'] = action.segmentsTabPayload,
          state.cust_summaryDetails['segments_tab_details']['value'] = action.segmentsTabValue
        }
        state = {
          ...state
        };
        break;
  }
  return state;
};

const store = createStore(reducer);

/*function saveToLocalStorage(state){
  try{
    const serializedState = JSON.stringify(state)
    localStorage.setItem('state', serializedState)
  }
  catch(e){
    console.log('1538')
    console.log(e)
  }
}

function loadFromLocalStorage(){
  try{
    const serializedState = localStorage.getItem('state')
    if(serializedState === null) return undefined
    return JSON.parse(serializedState)
  }
  catch(e){
    console.log('1551')
    console.log(e)
    return undefined
  }
}

const persistedState = loadFromLocalStorage()
const store = createStore(reducer, persistedState);

store.subscribe(() => saveToLocalStorage(store.getState()))*/

// store.subscribe(() => {
// 	return store.getState();
// });

export default store;



// WEBPACK FOOTER //
// ./src/store/index.jsx